<template>
    <rkm-form ref="Form">
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :value="true"
                    v-model="data.model.numeroRequisicaoAutomatico"
                >
                    Número de requisição automático
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :value="true"
                    v-model="data.model.permiteRequisitarMateriaisSemEstoque"
                >
                    Permite requisitar materiais sem estoque
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Bloquear requisição de material em estoque com vencimento próximo"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :label="false"
                        v-model="data.model.prazoValidade"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                dia(s)
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Motivo"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="data.model.motivoObrigatorio">
                        Obrigatoriedade do campo motivo quando o mesmo não for entregue ou entregue parcialmente.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
export default {
    methods: {
        validate() {

            return this.$refs.Form.validate()
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>